import React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import translate from '@/lib/intl/translate';
import { formatCurrencyWithDecimals } from '@/utils/currency';

type TicketCostBreakdownProps = {
  fmv?: number;
  fees?: number;
  taxes?: number;
  totalContributions: number;
  totalDonations: number;
};

export default function TicketCostBreakdown({
  fmv = 0,
  fees = 0,
  taxes = 0,
  totalContributions,
  totalDonations,
}: TicketCostBreakdownProps) {
  return (
    <Paper className="border-grey-300 p-4" variant="outlined">
      <div className="grid grid-cols-2 gap-3">
        <div className="type-body4">
          {translate('CONTRIBUTION_TOTAL_CONTRIBUTIONS')}
        </div>
        <div className="text-right type-body3">
          {formatCurrencyWithDecimals(totalContributions, true)}
        </div>

        {!!fmv && (
          <>
            <div className="type-body4">
              {translate('CONTRIBUTION_FMV', true)}
            </div>
            <div className="text-right type-body3">
              - {formatCurrencyWithDecimals(fmv, true)}
            </div>
          </>
        )}

        {!!fees && (
          <>
            <div className="type-body4">{translate('CONTRIBUTION_FEES')}</div>
            <div className="text-right type-body3">
              - {formatCurrencyWithDecimals(fees, true)}
            </div>
          </>
        )}

        {!!taxes && (
          <>
            <div className="type-body4">{translate('CONTRIBUTION_TAXES')}</div>
            <div className="text-right type-body3">
              - {formatCurrencyWithDecimals(taxes, true)}
            </div>
          </>
        )}
      </div>

      <Divider className="my-3" />

      <div className="grid grid-cols-2 gap-3">
        <div className="type-body4">
          {translate('CONTRIBUTION_TOTAL_DONATIONS')}
          <div className="text-2xs leading-[15px] text-text-secondary">
            {translate('CONTRIBUTION_TOTAL_DONATIONS_ESTIMATED')}
          </div>
        </div>
        <div className="text-right type-body3">
          {formatCurrencyWithDecimals(totalDonations, true)}
        </div>
      </div>
    </Paper>
  );
}
